import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Configuration } from '../../shared/services/configuration';
import { HttpClientCustom } from '../../shared/services/http.client';
import * as _ from 'underscore';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { Auth } from '../../shared/services/auth';
import { RouterModule, Router } from '@angular/router';
import { Location } from '@angular/common';
import { SharedData } from '../../shared/sharedData';
import { ToasterComponent } from '../../toasterComponent/toasterComponent';
import { ConfirmationComponent } from '../../confirmation/confirmation';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'employee-Roles-Permission',
    templateUrl: 'employeesInRole.html',
})
export class EmployeeInRoleComponent {
    public _baseUrl: any;
    public showLoading: any = true;
    public disabledButton: any = false;
    selectedAll: any;
    //pagination variables  and default values
    public pageSize: any = 10;
    public page = 1;
    public startingPage: any = 1;
    public endingPage: any = 10;
    public collectionSize: any;

    public allSelectedEmplUserIds: any = [];
    public employeeData: any = [];
    public employeePageData: any = {};
    public id: any;
    public searchData = {
        "nameOrCodeOrEmail": "",
        "employeeCodes": [],
        "excludedEmployeeCodes": [],
        "includeEmpIds": [],
        "excludeEmpIds": [],
        "gradeIds": [],
        "mgrLevelIds": [],
        "designationIds": [],
        "categoryIds": [],
        "includeOrgIds": [],
        "excludeOrgIds": [],
        "supervisorIds": [],
        "primarySupervisorIds": [],
        "primarySupervisorNameOrCode": null,
        "primarySupervisorCods": [],
        "employeeStatus": null,
        "employeesWithOutSupervisor": null,
        "scorecardStates": null,
        "memberShipState": null,
        "programId": null,
        "pageSize": 10,
        "page": 1,
        "fetchSupervisorLevels": 0
    }
    constructor(
        public route: ActivatedRoute,
        public modalService: NgbModal,
        public _global: Configuration,
        public _http: HttpClientCustom,
        public builder: FormBuilder,
        public _auth: Auth,
        public router: Router,
        public _location: Location,
        public share: SharedData,
        public _toaster: ToasterComponent,
        public translate:TranslateService,
        vcr: ViewContainerRef
    ) {
        this._baseUrl = _global.get("EPMS_BASE_URL");
        this.id = this.share.getData();
        
        if (isNaN(this.id)) {
            this._location.back();
        }
        else {
            this._toaster.setViewRef(vcr);
            this.getEmployeeDetails();
        }
    }

    getData() {
        _.each(this.employeeData, function (key, val) {
            key.selected = false;
        })
    }

    showSearchFilter(event) {
        ;
        this.searchData = event;
        this.getEmployeeDetails();
    }

    //pagination functions
  onPageChange(event: number): void {
    let that = this;
    if (event == 1) {
      that.startingPage = 1;
      that.endingPage = 10;
    } else {
      that.startingPage = 1 + that.pageSize;
      if (that.collectionSize > that.endingPage) {
        that.endingPage = event + that.endingPage;
      } else {
        that.endingPage = that.collectionSize;
      }
    }
    that.page = event;
    that.getEmployeeDetails();
  }
  OnPageSizeChanged(val) {
    this.pageSize = val;
    this.getEmployeeDetails();
  }


    deleteEmployee() {
        try {
            let that = this;
            that.disabledButton = true;
            let url = that._baseUrl + 'v1/webAdmin/role/deleterRoleUserRelation/' + that.id;
            that._http.post(url, that.allSelectedEmplUserIds).subscribe((result) => {
                if (result) {
                    this.translate.get('deleted').subscribe((msg)=>{
                        that._toaster.showSuccess(msg);
                    });
                    
                    that.getEmployeeDetails();
                } else {
                    this.translate.get('failedDelete').subscribe((msg)=>{
                        that._toaster.showError(msg);
                    });
                    that.disabledButton = false;
                }
            });
        } catch (e) {
            console.log('error', e);
        }
    }

    public clicked() {
    }

    getEmployeeDetails() {
        try {
            let that = this;
            let url = that._baseUrl + 'v1/webAdmin/role/getEmployeeInfoByRoleId/' + that.id;
            this.searchData.page=this.page;
            this.searchData.pageSize=this.pageSize;
            that._http.post(url, this.searchData).subscribe((result) => {
                that.selectedAll = false;
                that.disabledButton = false;
                that.employeeData = result.content;
                that.employeePageData = result;
                that.getData();
                if (that.employeeData.length == 0) {
                    that.showLoading = false;
                }

                that.collectionSize = result.totalElements;
                if (result.last) {
                    that.endingPage = that.collectionSize;
                }
            });
        } catch (e) {
            console.log('error', e);
        }
    }

    selectAll(event) {
        for (var i = 0; i < this.employeeData.length; i++) {
            this.employeeData[i].selected = this.selectedAll;
            this.getAllSelectedEmployee(this.employeeData[i], event);
        }
    }

    checkIfAllSelected(employee: any, $event) {
        this.selectedAll = this.employeeData.every(function (item: any) {
            return item.selected == true;
        });
        this.getAllSelectedEmployee(employee, $event);
    }

    getAllSelectedEmployee(emp, event) {
        let that = this;
        if (event.target.checked) {
            that.allSelectedEmplUserIds.push(emp.userId);
        } else {
            _.each(that.allSelectedEmplUserIds, function (key, val) {
                if (emp.userId == key) {
                    that.allSelectedEmplUserIds.splice(val, 1);
                }
            });
        }
    }

    goBack() {
        this._location.back();
    }

}



// WEBPACK FOOTER //
// ./src/app/tools/rolesAndPermission/employeesInRole.ts